import C from "../constants";
import { clickToLinkHandler } from "../helpers/utils";

export default {
  login: function (authData) {
    return {
      types: [C.LOGIN, C.LOGIN_SUCCESS, C.LOGIN_FAIL],
      promise: (client) =>
        client
          .post("/api/auth", {
            data: authData,
          })
          .then((response) => {
            return response;
          }),
    };
  },

  logout: function () {
    document.cookie =
      "portalapi=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    return {
      types: [C.LOGOUT, C.LOGOUT_SUCCESS, C.LOGOUT_FAIL],
      promise: () =>
        new Promise((resolve) => {
          const storedState = JSON.parse(
            window.localStorage.getItem(C.APP_NAME)
          );
          storedState.auth.token = "";
          storedState.auth.user = {};
          window.localStorage.setItem(C.APP_NAME, JSON.stringify(storedState));
          resolve(storedState);
        }).then((response) => {
          clickToLinkHandler("/");
          return {
            payload: response,
          };
        }),
    };
  },

  register: function (authData) {
    return {
      types: [C.REGISTER, C.REGISTER_SUCCESS, C.REGISTER_FAIL],
      promise: (client) =>
        client
          .post("/api/v1/companies", {
            data: {
              name: authData.company,
              firstName: authData.first_name,
              lastName: authData.last_name,
              email: authData.email,
            },
          })
          .then((result) => {
            return result;
          }),
    };
  },

  confirm: function (code) {
    return {
      types: [C.CONFIRM, C.CONFIRM_SUCCESS, C.CONFIRM_FAIL],
      promise: (client) =>
        client.get("/api/verify/" + code).then((result) => {
          return result;
        }),
    };
  },

  sentLetterForActivate: function (email) {
    return {
      types: [
        C.RESEND_CONFIRM,
        C.RESEND_CONFIRM_SUCCESS,
        C.RESEND_CONFIRM_FAIL,
      ],
      promise: (client) =>
        client
          .post("/api/resend_confirm_letter", {
            data: {
              email: email,
            },
          })
          .then((result) => {
            return result;
          }),
    };
  },

  forgotPassword: function (email) {
    return {
      types: [
        C.FORGOT_PASSWORD,
        C.FORGOT_PASSWORD_SUCCESS,
        C.FORGOT_PASSWORD_FAIL,
      ],
      promise: (client) =>
        client
          .post("/api/forgot_password", {
            data: {
              email: email,
            },
          })
          .then((result) => {
            return result;
          }),
    };
  },

  changePassword: function (data) {
    return {
      types: [
        C.CHANGE_PASSWORD,
        C.CHANGE_PASSWORD_SUCCESS,
        C.CHANGE_PASSWORD_FAIL,
      ],
      promise: (client) =>
        client
          .post("/api/change-password", {
            data: data,
          })
          .then((result) => {
            return result;
          }),
    };
  },

  hideHintVariable: function (type) {
    return {
      types: [C.HIDE_HINT, C.HIDE_HINT_SUCCESS, C.HIDE_HINT_FAIL],
      promise: (client) =>
        client
          .post("/api/hide-hint", {
            data: {
              type: type,
            },
          })
          .then((result) => {
            return result;
          }),
    };
  },

  getCurrentCompany: function (orgId) {
    return {
      types: [
        C.GET_CURRENT_COMPANY,
        C.GET_CURRENT_COMPANY_SUCCESS,
        C.GET_CURRENT_COMPANY_FAIL,
      ],
      promise: (client) =>
        client.get(`/api/v1/organizations/${orgId}/company`).then((result) => {
          return result;
        }),
    };
  },
};
